<template>
  <a-spin :spinning="fileLoading" style="width:100%;height:100vh">
    <div class="pdfBox">
      <pdf ref="pdfs" style="display: none;" :src="pdfUrl" class="pdf"></pdf>
      <div class="pdf">
      <pdf v-for="item in numPages" :key="item" :src="pdfUrl" :page="item" />
      </div>
      <div class="btnBox">
        <a-space>
          <a-button @click="downloadFile">下载</a-button>
          <a-button type="primary" @click="$refs.pdfs.print()">
            打印
          </a-button>
        </a-space>
      </div>
    </div>
  </a-spin>
</template>
<script>
import pdf from 'vue-pdf-signature'
import { nhfMixins } from '../untils'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'

export default {
  mixins:[nhfMixins],
  components:{
    pdf
  },
  data(){
    return {
      fileLoading:false,
      url: 'http://minio.liuheco.com/nhf-report/3d4e352970c64117bc33906e908bc6ab.pdf',
      pdfUrl:'',
      iframeUrl:'',
      numPages:'',
      formulaReportType:''
    }
  },
  
  mounted(){
    const {id,formulaReportType} = this.$route.query
    this.formulaId = id
    this.formulaReportType = formulaReportType
    this.getFileUrl(id,formulaReportType)
  },
  
  methods:{
  loadPdfPage(){
    this.pdfUrl.promise.then(pdf => {this.numPages = pdf.numPages;})
  },
   async getFileUrl(formulaId,formulaReportType){
      const {data} = await this.fetchGet({
        actions:this.formulaReportUrl,
        name:'url',
        loading:'fileLoading',
        data:{ formulaId,formulaReportType}
      })
      if(data){
        this.pdfUrl = pdf.createLoadingTask({ url:data, CMapReaderFactory })
        this.$nextTick(()=>{
          this.loadPdfPage()
        })
      } else {
        this.$message('报告生成失败！')
      }
    },
    
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.url)
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages
      }).catch(err => {
        console.error('pdf 加载失败', err);
      })
    },

    async downloadFile() {
      const a = document.createElement('a')
      const url = this.url // binding.value // 完整的url则直接使用
      const blob = await fetch(url).then(res => res.blob())
      a.href = URL.createObjectURL(blob)
      a.download = ''
      document.body.appendChild(a)
      a.click()
    },

    print(){
      
    }
  }
}
</script>

<style lang='scss' scoped>
.pdfBox{
  height: calc(100% - 80px);
  width: 900px;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  margin-top: 20px;
  background-color: #fff;
  .pdf{
    overflow: auto;
    height: calc(100% - 90px);
  }
  .btnBox{
    // height: 40px;
    text-align: right;
    // margin-top: 20px;
    padding: 20px 20px 0 20px;
    // box-shadow: 0 0 2px 2px rgba(0,0,0,0.3);
    border-top: 1px solid #f0f2f5;
    box-sizing: border-box;
  }
}
</style>